import { TZDate } from "@date-fns/tz";
import { TIME_ZONE } from 'resources/constants';
import { addMilliseconds, subMilliseconds } from 'date-fns';
import { DAYS_OF_WEEK, daysTranslations } from 'resources/constants';

export const MIDDLE_DAY = 12;
export const MILLISECONDS_IN_A_SECOND = 1000;
//ms to 10 minutes
const SAFETY_TIME_RANGE = 10 * 60 * MILLISECONDS_IN_A_SECOND;

export const BASE_AVAILABILITY = {
  startAt: null,
  endAt: null,
  days: null,
  endsDay: null,
  timeRanges: null,
  currentOrder: null,
  alwaysAvailable: false,
}

const pad = num => num.toString().padStart(2, "0");

export const getRangeOrder = (start, end) => {
  const now = TZDate.tz(TIME_ZONE);  

  const safelyEnd = addMilliseconds(end, SAFETY_TIME_RANGE);

  if(now <= start) return -1;
  if(now >= safelyEnd) return 1;
  return 0;
}

export const getDatesByTimeRange = (timeRange, addSafetyTime = false) => {
  let [startHr, startMins] = timeRange.start.split(":");
  let [endHr, endMins] = timeRange.end.split(":");

  startHr = parseInt(startHr);
  startMins = parseInt(startMins);
  endHr = parseInt(endHr);
  endMins = parseInt(endMins);

  const start = TZDate.tz(TIME_ZONE);
  start.setHours(startHr, startMins, 0, 0);

  let end = TZDate.tz(TIME_ZONE);

  //Range ends tomorrow
  if(endHr < startHr)
    end.setDate(end.getDate() + 1);

  end.setHours(endHr, endMins, 0, 0);
  if(!!addSafetyTime)
    end = subMilliseconds(end, SAFETY_TIME_RANGE);

  return ({start, end});
}  
export const BASE_PIVOT = {
  start: null,
  end: null,
  last: null
}
export const getMessage = (timeRange, days, i18n) => {
  const {lang, tag: translation} = i18n;

  let message = '';
  if(!days) message = translation('ALWAYS_AVAILABLE');
  else {
    message = '';
    days = DAYS_OF_WEEK.map( day => days.includes(day) ? day : null);
    days.push(days.shift());    

    let pivot = {...BASE_PIVOT};
    for(const day of days){
      if(day){
        if(!!pivot.start && !!pivot.last){
          pivot.end = day;
          continue;
        }
        if(!pivot.start && !!pivot.last){
          pivot.start = pivot.last;
          pivot.last = day;
          continue;
        }
        if(!pivot.last)
          pivot.last = day;
      } else {        
        message = getDaysBlockMssg(pivot, message, lang);
        pivot = {...BASE_PIVOT};
      }
    }
    message = getDaysBlockMssg(pivot, message, lang);
  }
  
  if(!!timeRange){
    let [startHour, startMins] = timeRange.start.split(':');
    let [endHour, endMins] = timeRange.end.split(':');

    let start = parseInt(startHour);
    const startPeriod = start - MIDDLE_DAY >= 0 ? 'PM' : 'AM';
    let end = parseInt(endHour);
    const endPeriod = end - MIDDLE_DAY >= 0 ? 'PM' : 'AM';

    start = start === 0 ? MIDDLE_DAY : start;
    end = end === 0 ? MIDDLE_DAY : end;

    const startMssg = ` ${translation('FROM')} ${pad(start <= MIDDLE_DAY ? start : start - MIDDLE_DAY)}:${pad(startMins)}${startPeriod}`;
    const endMssg = ` ${translation('TO')} ${pad(end <= MIDDLE_DAY ? end : end - MIDDLE_DAY)}:${pad(endMins)}${endPeriod}`;

    message += startMssg + endMssg;
  }

  return message;
}

export const getDaysBlockMssg = (block, mssg, lang) => {
  lang = !!lang ? 'en' : 'es';
  if(!block.start && !block.end && !block.last) return mssg;
  if(mssg.length > 0) mssg += ', '
  if(!!block.start && !block.end){
    const start = daysTranslations[block.start][lang];
    const last = daysTranslations[block.last][lang];
    mssg += start.slice(0,3) + ', ' + last.slice(0,3);
    return mssg;
  }
  if(!!block.start && !!block.end){
    const start = daysTranslations[block.start][lang];
    const end = daysTranslations[block.end][lang];
    mssg += start.slice(0,3) + '-' + end.slice(0,3);
    return mssg;
  }
  if(!!block.last){
    const last = daysTranslations[block.last][lang];
    mssg += last.slice(0,3);
  }
  return mssg;
}

export const getAvailability = (availabilityConfig) => {
  if(!availabilityConfig || !!availabilityConfig.alwaysAvailable) {
    return {...BASE_AVAILABILITY, alwaysAvailable: true};
  }
  const schedule = availabilityConfig.schedule && availabilityConfig.schedule[0] ? availabilityConfig.schedule[0] : null;
  const days = !!schedule && !!schedule.days ? schedule.days : null;

  const availability = {...BASE_AVAILABILITY, days}
  if(!!schedule && !!schedule.timeRanges && !!schedule.timeRanges[0]){
    const {start, end} = getDatesByTimeRange(schedule.timeRanges[0], true);

    availability.startAt = start;
    availability.endAt = end;
    availability.timeRanges = schedule.timeRanges[0];
    availability.currentOrder = getRangeOrder(start, end);

    if(!!days && days.lenght > 0)
      availability.endsDay = DAYS_OF_WEEK[end.getDay()];    
  }
  return availability;
}